// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

interface OwnProps {
    children: React.ReactNode;
    contentTitle?: string;
    extendedStyles?: CheckoutContentWrapperStyles;
    isReview?: boolean;
}

export interface CheckoutContentWrapperStyles {
    container?: InjectableCss;
    titleWrapper?: InjectableCss;
    titleText?: TypographyProps;
    contentWrapper?: InjectableCss;
}

export const checkoutContentWrapperStyles: CheckoutContentWrapperStyles = {};

const CheckoutContentWrapper = ({ children, contentTitle, extendedStyles, isReview }: OwnProps) => {
    const [styles] = React.useState(() => mergeWithCss(checkoutContentWrapperStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.titleText}>{contentTitle}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.contentWrapper} {...{ isReview }}>
                {children}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CheckoutContentWrapper;
